import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const FeaturesContext = createContext({ features: {}, loading: true, refresh: () => {} });

export function FeaturesProvider({ children }) {
  const [features, setFeatures] = useState({});
  const [loading, setLoading]   = useState(true);

  const refresh = () => {
    api.get('/features')
      .then(r => setFeatures(r.data.features || {}))
      .catch(() => setFeatures({}))
      .finally(() => setLoading(false));
  };

  useEffect(() => { refresh(); }, []);

  return (
    <FeaturesContext.Provider value={{ features, loading, refresh }}>
      {children}
    </FeaturesContext.Provider>
  );
}

export const useFeatures = () => useContext(FeaturesContext);
export default FeaturesContext;
